import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Tv, Map } from 'lucide-react';

const UniverseIntro = () => {
  const introLines = [
    "Over a hundred years.",
    "Brooklyn to Hollywood.",
    "The policy bank to the penthouse.",
    "The Bullies to the Waterfront.",
    "",
    "This is not one story.",
    "This is the whole story."
  ];

  const entryPoints = [
    { icon: BookOpen, title: "THE BOOKS", href: "#books" },
    { icon: Tv, title: "THE SERIES", href: "#series" },
    { icon: Map, title: "THE UNIVERSE", href: "#timeline" }
  ];

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="universe-intro" 
      data-testid="universe-intro-section"
      className="min-h-screen flex flex-col items-center justify-center py-24 px-6 bg-[#080C10]"
    >
      {/* Intro Text */}
      <div className="max-w-3xl text-center mb-20">
        {introLines.map((line, index) => (
          <motion.p
            key={index}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8, delay: index * 0.15 }}
            className={`font-['Cormorant_Garamond'] ${
              line === "" 
                ? "h-8" 
                : index >= 5 
                  ? "text-2xl sm:text-3xl md:text-4xl text-[#C9A84C] font-bold mt-4"
                  : "text-xl sm:text-2xl md:text-3xl text-[#E8E0D0]/80"
            }`}
            data-testid={`intro-line-${index}`}
          >
            {line}
          </motion.p>
        ))}
      </div>

      {/* Entry Point Cards */}
      <motion.div 
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, delay: 0.5 }}
        className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-4xl w-full"
        data-testid="entry-points"
      >
        {entryPoints.map((point, index) => (
          <motion.button
            key={point.title}
            onClick={() => scrollToSection(point.href)}
            whileHover={{ scale: 1.02, borderColor: 'rgba(201, 168, 76, 0.5)' }}
            whileTap={{ scale: 0.98 }}
            className="glass-card p-8 flex flex-col items-center gap-4 cursor-pointer group transition-all duration-300 hover:gold-border-glow"
            data-testid={`entry-point-${point.title.toLowerCase().replace(/\s/g, '-')}`}
          >
            <point.icon 
              size={32} 
              className="text-[#C9A84C] group-hover:scale-110 transition-transform duration-300" 
              strokeWidth={1.5}
            />
            <span className="font-['Outfit'] text-[#E8E0D0] text-sm tracking-[0.2em] uppercase font-semibold">
              {point.title}
            </span>
          </motion.button>
        ))}
      </motion.div>
    </section>
  );
};

export default UniverseIntro;
